import ApiClient from "@/api/ApiClient.ts";
import { flatten } from "lodash";

const state = {
  zones: null,
};

const mutations = {
  setZones(state, zones) {
    state.zones = zones;
  },
};

const actions = {
  async getZones({ commit }, idWorkgroup) {
    const params = {
      wgId: idWorkgroup,
    };
    try {
      const api = ApiClient();
      let response = await api.get("zones", { params });
      commit("setZones", flatten(response.data));
    } catch (error) {
      console.error("ERROR en getZones: ", error.message);
    }
  },
};

const getters = {
  zones(state) {
    return state.zones;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
